import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

interface UnitPartition {
    id: number;
    name: string;
    percentage: string | number;
}

interface Product {
    id: number;
    unitPartition?: UnitPartition[];
}

interface Props {
    value?: number | null;
    onChange: (partitionId: number | null) => void;
    disabled?: boolean;
    product?: Product; // Pass the full product object
}

const UnitPartitionSelector: React.FC<Props> = ({
    value,
    onChange,
    disabled = false,
    product,
}) => {
    const { t } = useTranslation();
    const [partitions, setPartitions] = useState<UnitPartition[]>([]);

    useEffect(() => {
        // Extract partitions from product
        if (product?.unitPartition && Array.isArray(product.unitPartition)) {
            setPartitions(product.unitPartition);
        } else {
            setPartitions([]);
        }
    }, [product]);

    return (
        <Select
            value={value}
            onChange={onChange}
            disabled={disabled || partitions.length === 0}
            placeholder={
                partitions.length === 0
                    ? t("no_partitions_available")
                    : t("select_unit_partition")
            }
            allowClear
            style={{ width: "100%" }}
        >
            {partitions.map((partition) => (
                <Option key={partition.id} value={partition.id}>
                    {partition.name} - {partition.percentage}%
                </Option>
            ))}
        </Select>
    );
};

export default UnitPartitionSelector;
